module.exports = __webpack_public_path__ + "static/media/product_incomplete.d110646b.svg";